module.exports = __webpack_public_path__ + "media/donate/shared/trust_logos/ssl_logo-7e31ddd8e8bc6aeab954ddd1884ebbf2.png";